export default function checkbox({ variables }) {
    return {
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    padding: variables.spacing_02,
                    "& .MuiSvgIcon-root": {
                        fontSize: "16px",
                    },
                    color: variables.interactive,
                    "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                        color: variables.interactive_selected,
                    },
                    "&.Mui-disabled": {
                        color: variables.text_disabled,
                    },
                },
                sizeSmall: {
                    "& .MuiSvgIcon-root": {
                        fontSize: "14px",
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=checkbox.js.map